import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import termsTemplateServices from '../termsTemplateServices';
import { useAlert } from '../../../../../../context/AlertContext';
import AppCKEditor from '../../../../../../components/AppInput/AppCKEditor';


function TermsTemplateForm({data,callBack }) {

    const {AppAlert} = useAlert();
    
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    


    const [title,setTitle] = useState("");
    const [details,setDetails] = useState("");

    

    const updateData = ()=>{
        setTitle(data.title);
        setDetails(data.details);
        setDialogStatus(true)
    }

    

    const addNew = ()=>{
        setTitle("");
        setDetails("");
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = () => {
        let payload = {
            title:title,
            details:details,
        }
        if(data){
            payload.id = data.id;
        }
        termsTemplateServices.save(payload).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add Terms</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
            >

                
                                
                                    <DialogTitle>{"Terms Template Form"}</DialogTitle>
                                    <DialogContent>
                                            <div className="row p-3">
                                                <div className="col-md-12 my-2" >
                                                    <div className="form-floating my-3">
                                                        <input type="text" className='form-control'  value={title} onChange={(e)=>setTitle(e.target.value)} />
                                                        <label for="floatingTextarea2">Title</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 my-2" >
                                                    <AppCKEditor value={details} setValue={setDetails} />
                                                </div>

                                            </div>
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="button" onClick={onSubmit} disabled={title==="" || details===""} >Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </DialogContent>
                                
            </Dialog>
        </>
    )
}

export default TermsTemplateForm